import { useGetApiV1NotificationMobileAppSharedSelectionSummary } from '@/shared/api/generated/hooks/notificationMobileAppController/useGetApiV1NotificationMobileAppSharedSelectionSummary';

/**
 * Hook para buscar o resumo de seleção de público da notificação.
 *
 * Dispara a chamada à API apenas quando há turmas E status selecionados.
 * Enquanto carrega, `totalStudents` é `null` e `isLoading` é `true`.
 *
 * @param classroomIds - IDs das turmas selecionadas
 * @param statusIds - IDs dos status de matrícula selecionados
 * @returns Contagem refinada de alunos pela API e estado de loading
 *
 * @example
 * ```tsx
 * const { totalStudents, isLoading } = useSelectionSummary(classroomIds, statusIds);
 * ```
 */
export function useSelectionSummary(classroomIds: readonly string[], statusIds: readonly string[]) {
  const enabled = classroomIds.length > 0 && statusIds.length > 0;

  const { data, isFetching } = useGetApiV1NotificationMobileAppSharedSelectionSummary(
    {
      ClassStudentIds: classroomIds.map(Number),
      EnrollmentStatus: statusIds.map(Number),
    },
    { query: { enabled } },
  );

  return {
    totalStudents: data?.totalStudents ?? null,
    isLoading: enabled && isFetching,
  } as const;
}
